import ModalS4ToS1 from "../modal_all/ModalS4ToS1";
import dayjs from "dayjs";
import dataStatusAR from "./dataStatusAR";

// true = รอบการส่ง (roundDate) ถึงกำหนดแล้ว (<= วันนี้) -> กดปุ่มยกเลิกได้
// ถ้ายังไม่ถึงรอบ (roundDate > วันนี้) -> กดไม่ได้
const isRoundReached = (record) => {
  if (!record || !record.roundDate) return false;
  return !dayjs(record.roundDate)
    .startOf("day")
    .isAfter(dayjs().startOf("day"));
};

const DataStatus = ({ dataStatusCase }) => {
  const findStatus = dataStatusAR.find(
    (item) => item.value === Number(dataStatusCase),
  );

  return <span>{findStatus?.label || "-"}</span>;
};
const columnsCase90 = (onSuccess) => [
  {
    title: "ลำดับ",
    key: "index",
    render: (text, record, index) => index + 1,
  },
  {
    title: "เลขสัญญา",
    dataIndex: "contno",
    key: "contno",
  },
  {
    title: "รายละเอียด",
    dataIndex: "cnam",
    //  render: (text, record) => `${record.MODEL} ${record.MODEL}`,
    key: "MODEL",
  },
  {
    title: "วันที่ CEO อนุมัติ",
    dataIndex: "decidedAt",
    render: (text, record) => `${dayjs(record.decidedAt).format("DD/MM/YYYY")}`,
    key: "decidedAt",
  },
  {
    title: "รอบการส่ง",
    dataIndex: "roundDate",
    render: (text, record) => `${dayjs(record.roundDate).format("DD/MM/YYYY")}`,
    key: "roundDate",
  },
  {
    title: "สถานะการส่ง",
    render: (text, record) => <DataStatus dataStatusCase={record.status} />,
    key: "status",
  },
  {
    title: "ประเภท",
    dataIndex: "caseType",
    render: (value, record) => (record.caseType === 1 ? "ที่ดิน" : "รถ"),
    key: "caseType",
  },
  {
    // title: "ตีงานกลับให้เร่งรัด",
    title: "ยกเลิกเคส",
    dataIndex: "contno",
    key: "backToS1",
    render: (value, record) =>
      record.status === 4 ? (
        <ModalS4ToS1
          data={record}
          onSuccess={onSuccess}
          // ล็อกปุ่มยกเลิกเมื่อ: ยังไม่ถึงรอบการส่ง หรือ tempFlagTno = true
          disabled={!isRoundReached(record) || record.tempFlagTno === true}
        />
      ) : null,
  },
  //   {
  //   title: "ตีงานกลับให้เร่งรัด",
  //   dataIndex: "contno",
  //   key: "backToS1",
  //   render: (value, record) =>
  //     record.status === 3 || record.status === 4 ? (
  //       <ModalS4ToS1 data={record} onSuccess={onSuccess} />
  //     ) : null,
  // },
];
export default columnsCase90;
